var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg27(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 7.71875H19.4062L16.3125 3.58437V1.15625C16.3125 0.7625 16.0375 0.5 15.625 0.5H7.375C6.9625 0.5 6.6875 0.7625 6.6875 1.15625V2.92813L10.4688 7.71875Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 9.03125H3.25V11.6562V17.5625V18.2188H9.4375V9.03125Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 18.2188H19.75V17.5625V11.6562V9.03125H10.8125V18.2188Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.71895L6.1375 4.37207L3.59375 7.71895H8.75Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 19.5312V21.5H19.0625C19.475 21.5 19.75 21.2375 19.75 20.8438V19.5312H10.8125Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 19.5312H3.25V20.8438C3.25 21.2375 3.525 21.5 3.9375 21.5H9.4375V19.5312Z",
    fill: "#118f84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_1418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg27);
export default __webpack_public_path__ + "static/media/27.9d5a6fe909398307676b9f2afc18b0e6.svg";
export { ForwardRef as ReactComponent };